<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00058.installation.proliferation.titre' | translate"
      [description]="
        'P00058.installation.proliferation.description' | translate
      "
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="
        'P00058.installation.proliferation.filtration2424.title' | translate
      "
      [nameCustom]="
        'P00058.installation.proliferation.filtration2424.smallTitle'
          | translate
      "
      [value]="actionStack!.getValue('pvPActivationFonction24') !== 0"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PompeVS_Parametrage1,
          'pvPActivationFonction24',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('pvPActivationFonction24') === 1) {
      <app-label-configuration
        [titleListe]="
          'P00058.installation.proliferation.filtration2424.seuil.title'
            | translate
        "
        [value]="actionStack!.getValue('pvPSeuilTemperature24')"
        [liste]="P00058SeuilTemperatureFiltration2424()"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.PompeVS_Parametrage1,
            'pvPSeuilTemperature24',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="
        'P00058.installation.proliferation.filtration2424.description'
          | translate
      "
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
